import Question from "./Question";
import { Card, CardBody, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import SurveySummary from "./SurveySummary";
import $ from "jquery";
import { IconArrowLeft, IconArrowRight } from "../../images/icons";
import { AppHelpers } from "../../Helpers/App/AppHelpers";
import {
  M1_QuestionConditions,
  M1_ContentVideoStatuses,
} from "../../Constants/Enums";

const SiteQuestions = ({
  surveyArray,
  register,
  getValues,
  answers,
  setAnswers,
  errors,
  unregister,
  isValid,
  watch,
  setValue,
  surveyAnswersData,
  isFinal,
  downloadPDF,
  trigger,
  setUserCurrentPage,
  userCurrentPage,
  setError,
  clearErrors,
  saveDataWithIntervals,
  survType,
  voucherAmount,
  reset,
  downloadFeedbackPDF,
  isSubmitLoading,
  setAreasHelper,
  setIsSubmitAvailable,
  isSubmitAvailable,
  developmentAreas,
  setDevelopmentAreas,
  checkAreas
}) => {
  const [currentCard, setCurrentCard] = useState(() => {
    return userCurrentPage ? parseInt(userCurrentPage) : 1;
  });
  const [conditionsArray, setConditionsArray] = useState([]);
  const [previousFormValues, setPreviousFormValues] = useState({});
  const [columnCopiedAnswersData, setColumnCopiedAnswersData] = useState();
  const [columnCopiedQuestionnaire, setColumnCopiedQuestionnaire] = useState();
  const [forceReloadHelper, setForceReloadHelper] = useState(1);
  const [currentIndexForScreen, setCurrentIndexForScreen] = useState(
    () => currentCard - 1
  );
  const [buttonsBody, setButtonsBody] = useState();
  const [isVideoEnded, setIsVideoEnded] = useState(1);
  const currentFormValues = watch();
  const [isSurveySorted, setIsSurveySorted] = useState(false);

  useEffect(() => {
    trigger();
    const toPush = [];
    if (conditionsArray?.length === 0) {
      surveyArray.forEach((screen, index) => {
        screen.questions.forEach((question, index) => {
          if (question.conditional_rules !== null) {
            let conditionalObj = JSON.parse(question.conditional_rules);
            conditionalObj.forEach((object, index) => {
              object["question_selector_id"] = question.selector_id;
              toPush.push(object);
            });
          }
        });
      });
      setConditionsArray(toPush);
    }

    surveyArray.sort((a, b) => a.order - b.order);
    surveyArray.forEach((surveyItem) => {
      surveyItem.questions.sort((a, b) => a.order - b.order);
    });
    setIsSurveySorted(true);
  }, []);

  useEffect(() => {
    if (!isFinal){
      setAnswers(JSON.parse(surveyAnswersData));
    }
  }, [surveyAnswersData]);

  useEffect(() => {
    if (!!currentCard) {
      setIsSubmitAvailable(currentCard === surveyArray.length + 1);
    }
  }, [currentCard]);

  useEffect(() => {
    let isDifferent = false;
    for (const fieldName in currentFormValues) {
      if (currentFormValues[fieldName] !== previousFormValues[fieldName]) {
        isDifferent = true;
        break;
      }
    }
    if (isDifferent) {
      setPreviousFormValues(currentFormValues);
    }
  }, [currentFormValues, previousFormValues]);

  useEffect(() => {
    trigger();
    const buttons = [];
    if (currentCard > 1 && currentCard !== surveyArray.length + 1) {
      buttons.push(
        <Button
          key="back"
          variant="secondary"
          className="mr-1 btn-back"
          onClick={showPreviousCard}
        >
          <span className="btns">
            <img src={AppHelpers.svgBase64(IconArrowLeft)} className="arrow-left" alt="Linia" />
            Wróć do poprzedniego ekranu
          </span>
        </Button>
      );
    }

    if (currentCard < surveyArray.length) {
      buttons.push(
        <Button
          key="next"
          variant="primary"
          className="mr-1 btn-next"
          disabled={
            !!Object.keys(errors).length ||
            isVideoEnded === M1_ContentVideoStatuses.UnValid.value
          }
          onClick={showNextCard}
        >
          <span className="btns">
            Przejdź do kolejnego ekranu
            <img
              src={AppHelpers.svgBase64(IconArrowRight)}
              className="arrow-right"
              alt="Następny ekran"
            />
          </span>
        </Button>
      );
    }

    if (currentCard === surveyArray.length) {
      buttons.push(
        <Button
          key="summary"
          variant="primary"
          className="mr-1 btn-next"
          disabled={
            !!Object.keys(errors).length ||
            isVideoEnded === M1_ContentVideoStatuses.UnValid.value
          }
          onClick={showSummaryCard}
        >
          <span className="btns">
            Przejdź do podsumowania
            <img
              src={AppHelpers.svgBase64(IconArrowRight)}
              className="arrow-right"
              alt="Poprzedni ekran"
            />
          </span>
        </Button>
      );
    }

    setButtonsBody(buttons);
  }, [isValid, currentCard, errors, previousFormValues, isVideoEnded, forceReloadHelper]);

  const setSurveyAnswers = () => {
    setAnswers(getValues());
  };

  const showNextCard = () => {
    setCurrentCard(currentCard + 1);
    setUserCurrentPage(currentCard + 1);
    setCurrentIndexForScreen((prevIndex) => prevIndex + 1);
    saveDataWithIntervals();
    scrollToTop();
  };

  const showSummaryCard = () => {
    /**
     * If check areas callback not provided not run. Resolve case for last questionnaire.
     * Should be separate to two organism.
     */
    if (checkAreas) {
      checkAreas();
    }

    setCurrentCard(currentCard + 1);
    setUserCurrentPage(currentCard + 1);
    setCurrentIndexForScreen((prevIndex) => prevIndex + 1);
    setSurveyAnswers();
    saveDataWithIntervals();
    scrollToTop();
  };

  const showPreviousCard = () => {
    clearErrors();
    setCurrentCard(currentCard - 1);
    setUserCurrentPage(currentCard - 1);
    setCurrentIndexForScreen((prevIndex) => prevIndex - 1);
    setIsVideoEnded(M1_ContentVideoStatuses.NoValid.value);
    scrollToTop();
  };

  //funkcja skrolująca na górę ekranu
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleInputChange = (id, matchingObjects) => {
    let isHidden = false;
    let valueOfElement = getValues(id);

    if (typeof valueOfElement == "undefined" || valueOfElement === "") {
      let data = getValues();
      let liczba;
      for (const key in data) {
        if (key.startsWith(`${id}`) && data[key] === true) {
          const indeksPodkreslenia = key.toString().indexOf("_");
          const fragmentPoPodkresleniu = key
            .toString()
            .substring(indeksPodkreslenia + 1);
          liczba = parseInt(fragmentPoPodkresleniu, 10);
        }
      }
      let questionElement;
      surveyArray.forEach((value) => {
        value.questions?.forEach((question) => {
          if (question?.selector_id === id) {
            questionElement = question;
          }
        });

        const answer = questionElement?.answers.find(
          (answer) => answer.id === liczba
        );
        valueOfElement = answer?.content;
      });
    }

    if (typeof valueOfElement == "undefined") {
      valueOfElement = getValues(id);
    }

    matchingObjects?.forEach((obj) => {
      switch (obj.type) {
        case M1_QuestionConditions.Bigger.value:
          if (valueOfElement < obj.condition) {
            $(`#questionCard-${obj.question_selector_id}`).removeClass(
              "d-none"
            );
          } else {
            $(`#questionCard-${obj.question_selector_id}`).addClass("d-none");
            setValue(obj.question_selector_id, "");
            isHidden = true;
          }
          break;
        case M1_QuestionConditions.Smaller.value:
          if (valueOfElement > obj.condition) {
            $(`#questionCard-${obj.question_selector_id}`).removeClass(
              "d-none"
            );
          } else {
            $(`#questionCard-${obj.question_selector_id}`).addClass("d-none");
            setValue(obj.question_selector_id, "");
            isHidden = true;
          }
          break;
        case M1_QuestionConditions.Different.value:
          if (valueOfElement != obj.condition) {
            $(`#questionCard-${obj.question_selector_id}`).removeClass(
              "d-none"
            );
          } else {
            $(`#questionCard-${obj.question_selector_id}`).addClass("d-none");
            setValue(obj.question_selector_id, "");
            isHidden = true;
          }
          break;
        case M1_QuestionConditions.Equal.value:
          if (valueOfElement === obj.condition) {
            $(`#questionCard-${obj.question_selector_id}`).removeClass(
              "d-none"
            );
          } else {
            $(`#questionCard-${obj.question_selector_id}`).addClass("d-none");
            setValue(obj.question_selector_id, "");
            isHidden = true;
          }
          break;
        case M1_QuestionConditions.Containing.value:
          if (valueOfElement.includes(obj.condition)) {
            $(`#questionCard-${obj.question_selector_id}`).removeClass(
              "d-none"
            );
          } else {
            $(`#questionCard-${obj.question_selector_id}`).addClass("d-none");
            setValue(obj.question_selector_id, "");
            isHidden = true;
          }
          break;
        case M1_QuestionConditions.Not_containing.value:
          if (valueOfElement.includes(obj.condition)) {
            $(`#questionCard-${obj.question_selector_id}`).removeClass(
              "d-none"
            );
          } else {
            $(`#questionCard-${obj.question_selector_id}`).addClass("d-none");
            setValue(obj.question_selector_id, "");
            isHidden = true;
          }
          break;
        default:
          break;
      }
    });
    return isHidden;
  };

  return (
    <>
      {!isFinal &&
        !!isSurveySorted &&
        currentIndexForScreen < surveyArray?.length && (
          <Card
            className="w-100 survey-screen"
            id={`screenPanel-${currentIndexForScreen + 1}`}
            style={{
              display:
                currentCard === currentIndexForScreen + 1 ? "block" : "none",
            }}
            key={`screenPanel-${currentIndexForScreen + 1}`}
          >
            <CardBody>
              {surveyArray[currentIndexForScreen]?.questions?.map(
                (question, questionIndex) => (
                  <Question
                    question={question}
                    register={register}
                    errors={errors}
                    handleInputChange={handleInputChange}
                    previousFormValues={previousFormValues}
                    conditionsArray={conditionsArray}
                    surveyArray={surveyArray}
                    currentPage={surveyArray[currentIndexForScreen]}
                    getValues={getValues}
                    setValue={setValue}
                    unregister={unregister}
                    watch={watch}
                    isValid={isValid}
                    isVideoEnded={isVideoEnded}
                    setIsVideoEnded={setIsVideoEnded}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    downloadFeedbackPDF={downloadFeedbackPDF}
                    reset={reset}
                    columnCopiedAnswersData={columnCopiedAnswersData}
                    setColumnCopiedAnswersData={setColumnCopiedAnswersData}
                    columnCopiedQuestionnaire={columnCopiedQuestionnaire}
                    setColumnCopiedQuestionnaire={setColumnCopiedQuestionnaire}
                    setAreasHelper={setAreasHelper}
                    developmentAreas={developmentAreas}
                    setDevelopmentAreas={setDevelopmentAreas}
                    forceReloadHelper={forceReloadHelper}
                    setForceReloadHelper={setForceReloadHelper}
                  />
                )
              )}
            </CardBody>
            <Card.Footer>{buttonsBody}</Card.Footer>
          </Card>
        )}
      {surveyArray ? (
        <Card
          key={surveyArray.length + 1}
          className="w-100 survey-screen"
          id={`screenPanel-${surveyArray.length + 1}`}
          style={{
            display:
              currentCard === surveyArray.length + 1 || isFinal
                ? "block"
                : "none",
          }}
        >
          <SurveySummary
            showPreviousCard={showPreviousCard}
            surveyData={surveyArray}
            answers={answers}
            isFinal={isFinal}
            idOfSurvey={surveyArray.id}
            downloadPDF={downloadPDF}
            survType={survType}
            isSubmitAvailable={isSubmitAvailable}
            isSubmitLoading={isSubmitLoading}
            voucherAmount={voucherAmount}
            setAnswers={setAnswers}
            getValues={getValues}
          />
        </Card>
      ) : null}
    </>
  );
};

export default SiteQuestions;
